<app-landing-header *ngIf="!(authService.isLoggedIn$ | async)"></app-landing-header>
<app-header *ngIf="authService.isLoggedIn$ | async"></app-header>
<div class="main-container">
  <h1>{{ 'general.terms_title' | translate }}</h1>
  <div class="html-content" [innerHTML]="(data$ | async)! | sanitizeHtml"></div>
</div>
<app-footer></app-footer>
